import { client } from '@api';
import { IntrospectResponse, IntrospectInfo, INTROSPECT } from '@requests/cart';

export const introspectToken = async (
  almToken?: string,
  ecomToken?: string,
  connectAccessToken?: string,
  connectIdToken?: string,
): Promise<IntrospectInfo> => {
  try {
    if (!almToken && !connectAccessToken) return { tokenIsValid: false };

    const result = await client.request<IntrospectResponse>(INTROSPECT, {
      token: almToken || connectAccessToken,
      ecomToken,
      idToken: connectIdToken,
    });
    return result.wEcomIntrospect.result.data;
  } catch (err) {
    return { tokenIsValid: false };
  }
};
